export default __webpack_public_path__ + "static/media/latest2.7609b431.png";